import { render, staticRenderFns } from "./KioskAdd.vue?vue&type=template&id=0dce8b28&"
import script from "./KioskAdd.vue?vue&type=script&lang=js&"
export * from "./KioskAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports